// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.team_teamDatatableList__Fjz7D {
    padding: 30px 30px 0;
}

.team_teamHeader__i-DxW {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    gap: 10px;
    flex-wrap: wrap;
}

.team_teamHeader__i-DxW .team_teamHeading__4e9qu {
    font-size: 20px;
    font-weight: 600;
}

.team_leftSide__AXMut {
    display: flex;
    align-items: center;
    gap: 10px;
}

.team_searchBar__TNUz2 {
    display: flex;
    align-items: center;
    border: 1px solid #ddd;
    border-radius: 6px;
    padding: 8px 12px;
    min-width: 400px;
    height: 40px;
}

.team_searchBar__TNUz2 img {
    width: 16px;
    height: 16px;
    margin-right: 8px;
}

.team_searchBar__TNUz2 input {
    border: none;
    outline: none;
    padding: 8px 0;
    width: 100%;
    font-size: 14px;
}

.team_searchBar__TNUz2 input::placeholder {
    color: #667085;
}

.team_addBtn__m5-6S {
    background: #000;
    color: white;
    padding: 10px 18px;
    border-radius: 6px;
    border: none;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
}

.team_actionButtonsDeleteAdd__H2TVq {
    display: flex;
    align-items: center;
    gap: 12px;
}

.team_deleteSelectedBtn__BgiQw {
    cursor: pointer;
    padding: 8px;
    background-color: #dc3545;
    border-radius: 6px;
    border: none;
}

.team_deleteSelectedBtn__BgiQw:hover {
    background-color: #c82333;
}

/* Role Badge Styles */
.team_roleBadge__wX3GX {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.team_userRole__-NHKd {
    padding: 2px 4px;
    font-size: 14px;
    border-radius: 8px;
    border: 1px solid var(--eerieblack);
}

/* Role Filter Dropdown */
.team_roleFilterDropdown__b\\+CMk {
    margin-left: 10px;
    min-width: 150px;
    position: relative;
}

.team_dropdownHeader__IXfm8 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 6px;
    background-color: white;
    cursor: pointer;
    min-height: 40px;
    font-size: 14px;
}

.team_dropdownHeader__IXfm8 .team_title__0hEEQ {
    flex: 1 1;
}

.team_dropdownHeader__IXfm8 .team_arrow__s96vk {
    transition: transform 0.2s;
    margin-left: 8px;
}

.team_dropdownHeader__IXfm8 .team_arrow__s96vk.team_rotate__ufUaK {
    transform: rotate(180deg);
}

.team_dropdownList__PvGxc {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #ddd;
    border-radius: 6px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    max-height: 200px;
    overflow-y: auto;
}

.team_dropdownItem__QdlPv {
    padding: 10px 12px;
    cursor: pointer;
    font-size: 14px;
    border-bottom: 1px solid #f5f5f5;
}

.team_dropdownItem__QdlPv:hover {
    background-color: #f8f9fa;
}

.team_dropdownItem__QdlPv:last-child {
    border-bottom: none;
}

/* AddTeamMember Dropdown Styles */
.team_parentCategoryListDropdown__QV7a7 {
    position: relative;
    width: 100%;
}

.team_parentCategoryListDropdown__QV7a7 .team_dropdownHeader__IXfm8 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    border: 1px solid #d0d5dd;
    border-radius: 6px;
    background-color: white;
    cursor: pointer;
    min-height: 45px;
    font-size: 14px;
    margin-top: 10px;
    width: 100%;
}

.team_parentCategoryListDropdown__QV7a7 .team_dropdownHeader__IXfm8 .team_title__0hEEQ {
    flex: 1 1;
    color: #344054;
}

.team_parentCategoryListDropdown__QV7a7 .team_dropdownHeader__IXfm8 .team_arrow__s96vk {
    transition: transform 0.2s;
    margin-left: 8px;
}

.team_parentCategoryListDropdown__QV7a7 .team_dropdownHeader__IXfm8 .team_arrow__s96vk.team_rotate__ufUaK {
    transform: rotate(180deg);
}

.team_parentCategoryListDropdown__QV7a7 .team_dropdownList__PvGxc {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #d0d5dd;
    border-radius: 6px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    max-height: 200px;
    overflow-y: auto;
    margin-top: 4px;
}

.team_parentCategoryListDropdown__QV7a7 .team_dropdownItem__QdlPv {
    padding: 12px;
    cursor: pointer;
    font-size: 14px;
    border-bottom: 1px solid #f5f5f5;
    color: #344054;
}

.team_parentCategoryListDropdown__QV7a7 .team_dropdownItem__QdlPv:hover {
    background-color: #f8f9fa;
}

.team_parentCategoryListDropdown__QV7a7 .team_dropdownItem__QdlPv:last-child {
    border-bottom: none;
}

/* Permission Badges */
.team_permissionBadges__mBxqQ {
    display: flex;
    gap: 8px;
    align-items: center;
}

.team_readBadge__EqucQ, .team_writeBadge__LGs7g {
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.team_readBadge__EqucQ {
    background-color: #e3f2fd;
    color: #1976d2;
    border: 1px solid #bbdefb;
}

.team_writeBadge__LGs7g {
    background-color: #f3e5f5;
    color: #7b1fa2;
    border: 1px solid #ce93d8;
}

.team_noPermissions__4sXSW {
    text-align: center;
    color: #666;
    font-style: italic;
    padding: 20px;
}

/* NewRole Styles */
.team_settingsMenuList__fHQIs {
    /* min-height: calc(100vh - 343px); */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 30px 30px 0;
}

.team_settingsMenuList__fHQIs .team_pageSearchInput__T7sHp {
    width: 100%;
    margin-top: 0;
}

.team_settingsMenuList__fHQIs #team_pages_search__su0jE {
    position: relative;
    right: 0;
}

.team_settingsListWrap__yRr1F {
    display: flex;
    margin-bottom: 30px;
}

.team_navLeftList__dt85p {
    max-width: 350px;
    min-width: 350px;
}

.team_settingsMenuBlockTitle__ycuVp {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    color: var(--cloudburst);
}

.team_titleBottom__S6Ftp {
    padding: 0 0 15px;
    margin-bottom: 0;
}

.team_navigationLeft__1T0sm {
    background: var(--white);
    border-width: 1px;
    border-style: solid;
    border-color: var(--ashyblue);
    border-radius: 6px;
}

.team_navigationBlocks__SR3RQ {
    border-bottom: 1px solid var(--lightgrey);
    width: 100%;
    padding-top: 0px;
    padding-bottom: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.team_navigationBlocks__SR3RQ>div {
    overflow: hidden;
}

.team_pagesTitle__1EKps {
    padding-right: 18px;
    padding-left: 18px;
    padding: 1rem 1.5rem;
    position: relative;
    cursor: pointer;
    margin: 0;
}

.team_pagesTitle__1EKps.team_active__TvQFV::before {
    transform: rotate(180deg);
}

.team_settingsMenuPages__4cazB {
    padding-right: 24px;
    padding-left: 24px;
    overflow: hidden;
    display: flex;
    gap: 10px;
}

.team_settingsMenuItem__556HP input {
    background: var(--white);
    -o-appearance: none;
    appearance: none;
    outline: none;
    content: none;
    border: none !important;
    outline: none;
    cursor: pointer;
    width: 25px;
}

.team_settingsMenuItem__556HP {
    display: flex;
    cursor: pointer;
}

.team_settingsMenuItem__556HP input {
    margin-top: 2px;
}

.team_settingsMenuItem__556HP p,
.team_settingsMenuItem__556HP label {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: left;
    color: var(--cloudburst);
    cursor: pointer;
}

.team_navigationRight__gfsr7 {
    margin-left: 35px;
    padding-top: 0;
    min-width: 300px;
}

.team_navigationRight__gfsr7 .team_navItem__5qNNz {
    width: 380px;
}

.team_navRightList__0P\\+Cl {
    margin-top: 15px;
}

.team_menuTop__SV5Y8 {
    display: flex;
    gap: 10px;
}

.team_menuSorter__TWDsh {
  position: relative;
}

.team_menuItemRow__hqeIW {
    cursor: pointer;
}

.team_menuItemRow__hqeIW,
.team_dragPreviewItem__Zs97U {
  border: 1px solid #d0d7de;
  border-radius: 6px;
  padding: 16px;
  margin-bottom: 10px;
  width: 380px;
  background: #fff;
}

.team_menuItem__ACKTY {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  background: #fff;
}

.team_menuItem__ACKTY,
.team_menuItem__ACKTY * {
  -webkit-user-select: none;
          user-select: none;
}

.team_menuTitleFront__LVdwf,
.team_menuItemTitle__YDTzi,
.team_dragPreviewItemTitle__wOcSJ {
    font-size: 14px;
}

.team_saveButtons__qJzZ4 {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-top: 25px;
    padding-top: 25px;
    border-top: 1px solid var(--lightgrey);
    gap: 0 15px;
}

.team_saveButton__z7R9C,
.team_deleteButton__5mq4A {
    display: inline-block;
    font-size: 14px;
    font-weight: 500;
    color: #fff;
    line-height: 22px;
    border-radius: 6px;
    cursor: pointer;
    white-space: nowrap;
    background-color: #000;
    border-color: transparent;
    padding: 8px 13px;
    text-align: center;
    width: auto;
    min-height: 42px;
}

.team_saveButtons__qJzZ4 .team_saveButton__z7R9C{
    width: 66px;
    height: 42px;
}

.team_deleteButton__5mq4A {
    background-color: #eb1e1e;
    color: #fff;
    border: 1px solid #eb1e1e;
}

.team_btnLoading__13LuW {
    opacity: 0.6;
    cursor: not-allowed;
}

.team_menuAddInput__EHz0E {
    width: 100%;
    height: 40px;
    background: var(--white);
    border: 1px solid var(--ashyblue);
    border-radius: 6px;
    padding: 10px 14px;
    outline: none;
    position: relative;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: var(--darkblue);
}

.team_addMenuContent__6oxoV .team_addBtn__m5-6S {
    margin-top: 10px;
    width: 71.41px;
    height: 39px;
}

/* Media Queries for NewRole */
@media screen and (max-width: 1260px) {
    .team_settingsListWrap__yRr1F .team_navLeftList__dt85p {
        max-width: 100%;
        min-width: unset;
        margin-bottom: 20px;
    }

    .team_settingsListWrap__yRr1F {
        display: block;
    }

    .team_navLeftList__dt85p .team_navigationLeft__1T0sm {
        min-width: auto;
        max-width: 100%;
    }
}

@media screen and (max-width: 1100px) {
    .team_navigationRight__gfsr7 .team_navItem__5qNNz {
        width: 100%;
    }
}

@media screen and (max-width: 1024px) {
    .team_navigationLeft__1T0sm,
    .team_navigationRight__gfsr7 {
        max-width: 100%;
        min-width: 100%;
    }

    .team_navigationRight__gfsr7 {
        margin-left: 0px;
        padding-left: 0px;
        padding-bottom: 20px;
    }

    .team_navItem__5qNNz {
        width: 100%;
    }
}

@media screen and (max-width: 768px) {
    .team_searchBar__TNUz2,
    .team_leftSide__AXMut {
        width: calc(100% - 50px);
        min-width: calc(100% - 50px);
    }

    .team_roleFilterDropdown__b\\+CMk {
        margin-left: 0;
        margin-top: 10px;
        min-width: 100%;
    }

    .team_teamHeader__i-DxW {
        flex-direction: column;
        align-items: stretch;
    }

    .team_actionButtonsDeleteAdd__H2TVq {
        justify-content: flex-start;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Team/team.module.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,cAAc;IACd,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,sBAAsB;AACtB;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA,yBAAyB;AACzB;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;IACb,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA,kCAAkC;AAClC;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,SAAO;IACP,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,eAAe;IACf,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,aAAa;AACjB;;AAEA,mBAAmB;AACnB;IACI,qCAAqC;IACrC,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,yCAAyC;IACzC,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,SAAS;AACb;;AAEA;IACI,wBAAwB;IAGxB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;;;IAGI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,sCAAsC;IACtC,WAAW;AACf;;AAEA;;IAEI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,iCAAiC;IACjC,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,YAAY;AAChB;;AAEA,8BAA8B;AAC9B;IACI;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;;QAEI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;;QAEI,wBAAwB;QACxB,4BAA4B;IAChC;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,2BAA2B;IAC/B;AACJ","sourcesContent":[".teamDatatableList {\n    padding: 30px 30px 0;\n}\n\n.teamHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.teamHeader .teamHeading {\n    font-size: 20px;\n    font-weight: 600;\n}\n\n.leftSide {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.searchBar {\n    display: flex;\n    align-items: center;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    padding: 8px 12px;\n    min-width: 400px;\n    height: 40px;\n}\n\n.searchBar img {\n    width: 16px;\n    height: 16px;\n    margin-right: 8px;\n}\n\n.searchBar input {\n    border: none;\n    outline: none;\n    padding: 8px 0;\n    width: 100%;\n    font-size: 14px;\n}\n\n.searchBar input::placeholder {\n    color: #667085;\n}\n\n.addBtn {\n    background: #000;\n    color: white;\n    padding: 10px 18px;\n    border-radius: 6px;\n    border: none;\n    cursor: pointer;\n    font-weight: 500;\n    font-size: 14px;\n}\n\n.actionButtonsDeleteAdd {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.deleteSelectedBtn {\n    cursor: pointer;\n    padding: 8px;\n    background-color: #dc3545;\n    border-radius: 6px;\n    border: none;\n}\n\n.deleteSelectedBtn:hover {\n    background-color: #c82333;\n}\n\n/* Role Badge Styles */\n.roleBadge {\n    display: inline-block;\n    padding: 4px 12px;\n    border-radius: 20px;\n    font-size: 12px;\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.userRole {\n    padding: 2px 4px;\n    font-size: 14px;\n    border-radius: 8px;\n    border: 1px solid var(--eerieblack);\n}\n\n/* Role Filter Dropdown */\n.roleFilterDropdown {\n    margin-left: 10px;\n    min-width: 150px;\n    position: relative;\n}\n\n.dropdownHeader {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 8px 12px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    background-color: white;\n    cursor: pointer;\n    min-height: 40px;\n    font-size: 14px;\n}\n\n.dropdownHeader .title {\n    flex: 1;\n}\n\n.dropdownHeader .arrow {\n    transition: transform 0.2s;\n    margin-left: 8px;\n}\n\n.dropdownHeader .arrow.rotate {\n    transform: rotate(180deg);\n}\n\n.dropdownList {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    background: white;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    z-index: 1000;\n    max-height: 200px;\n    overflow-y: auto;\n}\n\n.dropdownItem {\n    padding: 10px 12px;\n    cursor: pointer;\n    font-size: 14px;\n    border-bottom: 1px solid #f5f5f5;\n}\n\n.dropdownItem:hover {\n    background-color: #f8f9fa;\n}\n\n.dropdownItem:last-child {\n    border-bottom: none;\n}\n\n/* AddTeamMember Dropdown Styles */\n.parentCategoryListDropdown {\n    position: relative;\n    width: 100%;\n}\n\n.parentCategoryListDropdown .dropdownHeader {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 8px 12px;\n    border: 1px solid #d0d5dd;\n    border-radius: 6px;\n    background-color: white;\n    cursor: pointer;\n    min-height: 45px;\n    font-size: 14px;\n    margin-top: 10px;\n    width: 100%;\n}\n\n.parentCategoryListDropdown .dropdownHeader .title {\n    flex: 1;\n    color: #344054;\n}\n\n.parentCategoryListDropdown .dropdownHeader .arrow {\n    transition: transform 0.2s;\n    margin-left: 8px;\n}\n\n.parentCategoryListDropdown .dropdownHeader .arrow.rotate {\n    transform: rotate(180deg);\n}\n\n.parentCategoryListDropdown .dropdownList {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    background: white;\n    border: 1px solid #d0d5dd;\n    border-radius: 6px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    z-index: 1000;\n    max-height: 200px;\n    overflow-y: auto;\n    margin-top: 4px;\n}\n\n.parentCategoryListDropdown .dropdownItem {\n    padding: 12px;\n    cursor: pointer;\n    font-size: 14px;\n    border-bottom: 1px solid #f5f5f5;\n    color: #344054;\n}\n\n.parentCategoryListDropdown .dropdownItem:hover {\n    background-color: #f8f9fa;\n}\n\n.parentCategoryListDropdown .dropdownItem:last-child {\n    border-bottom: none;\n}\n\n/* Permission Badges */\n.permissionBadges {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n}\n\n.readBadge, .writeBadge {\n    padding: 2px 8px;\n    border-radius: 12px;\n    font-size: 11px;\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.readBadge {\n    background-color: #e3f2fd;\n    color: #1976d2;\n    border: 1px solid #bbdefb;\n}\n\n.writeBadge {\n    background-color: #f3e5f5;\n    color: #7b1fa2;\n    border: 1px solid #ce93d8;\n}\n\n.noPermissions {\n    text-align: center;\n    color: #666;\n    font-style: italic;\n    padding: 20px;\n}\n\n/* NewRole Styles */\n.settingsMenuList {\n    /* min-height: calc(100vh - 343px); */\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    padding: 30px 30px 0;\n}\n\n.settingsMenuList .pageSearchInput {\n    width: 100%;\n    margin-top: 0;\n}\n\n.settingsMenuList #pages_search {\n    position: relative;\n    right: 0;\n}\n\n.settingsListWrap {\n    display: flex;\n    margin-bottom: 30px;\n}\n\n.navLeftList {\n    max-width: 350px;\n    min-width: 350px;\n}\n\n.settingsMenuBlockTitle {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 24px;\n    color: var(--cloudburst);\n}\n\n.titleBottom {\n    padding: 0 0 15px;\n    margin-bottom: 0;\n}\n\n.navigationLeft {\n    background: var(--white);\n    border-width: 1px;\n    border-style: solid;\n    border-color: var(--ashyblue);\n    border-radius: 6px;\n}\n\n.navigationBlocks {\n    border-bottom: 1px solid var(--lightgrey);\n    width: 100%;\n    padding-top: 0px;\n    padding-bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.navigationBlocks>div {\n    overflow: hidden;\n}\n\n.pagesTitle {\n    padding-right: 18px;\n    padding-left: 18px;\n    padding: 1rem 1.5rem;\n    position: relative;\n    cursor: pointer;\n    margin: 0;\n}\n\n.pagesTitle.active::before {\n    transform: rotate(180deg);\n}\n\n.settingsMenuPages {\n    padding-right: 24px;\n    padding-left: 24px;\n    overflow: hidden;\n    display: flex;\n    gap: 10px;\n}\n\n.settingsMenuItem input {\n    background: var(--white);\n    -moz-appearance: none;\n    -webkit-appearance: none;\n    -o-appearance: none;\n    appearance: none;\n    outline: none;\n    content: none;\n    border: none !important;\n    outline: none;\n    cursor: pointer;\n    width: 25px;\n}\n\n.settingsMenuItem {\n    display: flex;\n    cursor: pointer;\n}\n\n.settingsMenuItem input {\n    margin-top: 2px;\n}\n\n.settingsMenuItem p,\n.settingsMenuItem label {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    text-align: left;\n    color: var(--cloudburst);\n    cursor: pointer;\n}\n\n.navigationRight {\n    margin-left: 35px;\n    padding-top: 0;\n    min-width: 300px;\n}\n\n.navigationRight .navItem {\n    width: 380px;\n}\n\n.navRightList {\n    margin-top: 15px;\n}\n\n.menuTop {\n    display: flex;\n    gap: 10px;\n}\n\n.menuSorter {\n  position: relative;\n}\n\n.menuItemRow {\n    cursor: pointer;\n}\n\n.menuItemRow,\n.dragPreviewItem {\n  border: 1px solid #d0d7de;\n  border-radius: 6px;\n  padding: 16px;\n  margin-bottom: 10px;\n  width: 380px;\n  background: #fff;\n}\n\n.menuItem {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  background: #fff;\n}\n\n.menuItem,\n.menuItem * {\n  user-select: none;\n}\n\n.menuTitleFront,\n.menuItemTitle,\n.dragPreviewItemTitle {\n    font-size: 14px;\n}\n\n.saveButtons {\n    display: flex;\n    justify-content: flex-end;\n    width: 100%;\n    margin-top: 25px;\n    padding-top: 25px;\n    border-top: 1px solid var(--lightgrey);\n    gap: 0 15px;\n}\n\n.saveButton,\n.deleteButton {\n    display: inline-block;\n    font-size: 14px;\n    font-weight: 500;\n    color: #fff;\n    line-height: 22px;\n    border-radius: 6px;\n    cursor: pointer;\n    white-space: nowrap;\n    background-color: #000;\n    border-color: transparent;\n    padding: 8px 13px;\n    text-align: center;\n    width: auto;\n    min-height: 42px;\n}\n\n.saveButtons .saveButton{\n    width: 66px;\n    height: 42px;\n}\n\n.deleteButton {\n    background-color: #eb1e1e;\n    color: #fff;\n    border: 1px solid #eb1e1e;\n}\n\n.btnLoading {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.menuAddInput {\n    width: 100%;\n    height: 40px;\n    background: var(--white);\n    border: 1px solid var(--ashyblue);\n    border-radius: 6px;\n    padding: 10px 14px;\n    outline: none;\n    position: relative;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    color: var(--darkblue);\n}\n\n.addMenuContent .addBtn {\n    margin-top: 10px;\n    width: 71.41px;\n    height: 39px;\n}\n\n/* Media Queries for NewRole */\n@media screen and (max-width: 1260px) {\n    .settingsListWrap .navLeftList {\n        max-width: 100%;\n        min-width: unset;\n        margin-bottom: 20px;\n    }\n\n    .settingsListWrap {\n        display: block;\n    }\n\n    .navLeftList .navigationLeft {\n        min-width: auto;\n        max-width: 100%;\n    }\n}\n\n@media screen and (max-width: 1100px) {\n    .navigationRight .navItem {\n        width: 100%;\n    }\n}\n\n@media screen and (max-width: 1024px) {\n    .navigationLeft,\n    .navigationRight {\n        max-width: 100%;\n        min-width: 100%;\n    }\n\n    .navigationRight {\n        margin-left: 0px;\n        padding-left: 0px;\n        padding-bottom: 20px;\n    }\n\n    .navItem {\n        width: 100%;\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .searchBar,\n    .leftSide {\n        width: calc(100% - 50px);\n        min-width: calc(100% - 50px);\n    }\n\n    .roleFilterDropdown {\n        margin-left: 0;\n        margin-top: 10px;\n        min-width: 100%;\n    }\n\n    .teamHeader {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .actionButtonsDeleteAdd {\n        justify-content: flex-start;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"teamDatatableList": `team_teamDatatableList__Fjz7D`,
	"teamHeader": `team_teamHeader__i-DxW`,
	"teamHeading": `team_teamHeading__4e9qu`,
	"leftSide": `team_leftSide__AXMut`,
	"searchBar": `team_searchBar__TNUz2`,
	"addBtn": `team_addBtn__m5-6S`,
	"actionButtonsDeleteAdd": `team_actionButtonsDeleteAdd__H2TVq`,
	"deleteSelectedBtn": `team_deleteSelectedBtn__BgiQw`,
	"roleBadge": `team_roleBadge__wX3GX`,
	"userRole": `team_userRole__-NHKd`,
	"roleFilterDropdown": `team_roleFilterDropdown__b+CMk`,
	"dropdownHeader": `team_dropdownHeader__IXfm8`,
	"title": `team_title__0hEEQ`,
	"arrow": `team_arrow__s96vk`,
	"rotate": `team_rotate__ufUaK`,
	"dropdownList": `team_dropdownList__PvGxc`,
	"dropdownItem": `team_dropdownItem__QdlPv`,
	"parentCategoryListDropdown": `team_parentCategoryListDropdown__QV7a7`,
	"permissionBadges": `team_permissionBadges__mBxqQ`,
	"readBadge": `team_readBadge__EqucQ`,
	"writeBadge": `team_writeBadge__LGs7g`,
	"noPermissions": `team_noPermissions__4sXSW`,
	"settingsMenuList": `team_settingsMenuList__fHQIs`,
	"pageSearchInput": `team_pageSearchInput__T7sHp`,
	"pages_search": `team_pages_search__su0jE`,
	"settingsListWrap": `team_settingsListWrap__yRr1F`,
	"navLeftList": `team_navLeftList__dt85p`,
	"settingsMenuBlockTitle": `team_settingsMenuBlockTitle__ycuVp`,
	"titleBottom": `team_titleBottom__S6Ftp`,
	"navigationLeft": `team_navigationLeft__1T0sm`,
	"navigationBlocks": `team_navigationBlocks__SR3RQ`,
	"pagesTitle": `team_pagesTitle__1EKps`,
	"active": `team_active__TvQFV`,
	"settingsMenuPages": `team_settingsMenuPages__4cazB`,
	"settingsMenuItem": `team_settingsMenuItem__556HP`,
	"navigationRight": `team_navigationRight__gfsr7`,
	"navItem": `team_navItem__5qNNz`,
	"navRightList": `team_navRightList__0P+Cl`,
	"menuTop": `team_menuTop__SV5Y8`,
	"menuSorter": `team_menuSorter__TWDsh`,
	"menuItemRow": `team_menuItemRow__hqeIW`,
	"dragPreviewItem": `team_dragPreviewItem__Zs97U`,
	"menuItem": `team_menuItem__ACKTY`,
	"menuTitleFront": `team_menuTitleFront__LVdwf`,
	"menuItemTitle": `team_menuItemTitle__YDTzi`,
	"dragPreviewItemTitle": `team_dragPreviewItemTitle__wOcSJ`,
	"saveButtons": `team_saveButtons__qJzZ4`,
	"saveButton": `team_saveButton__z7R9C`,
	"deleteButton": `team_deleteButton__5mq4A`,
	"btnLoading": `team_btnLoading__13LuW`,
	"menuAddInput": `team_menuAddInput__EHz0E`,
	"addMenuContent": `team_addMenuContent__6oxoV`
};
export default ___CSS_LOADER_EXPORT___;
